<div class="footer-container__table-footer">
  <label>Show</label>
  <dcc-dropdown
    class="footer-container__dropdown"
    [pageSizes]="pageSizes"
    [selectedSize]="pageSize"
    (changedPageSize)="onPageSizeSelected($event)"></dcc-dropdown>
  <label>Items</label>
</div>
